import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'next/router'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { withTranslation } from 'react-i18next'
import { Alert, Input, Button, Form, message } from 'antd'
import Head from '../components/layout/head'
import { sendPasswordRequestEmail, initSendPasswordRequestEmail, clearError } from '../actions'
import { Footer } from 'antd/lib/layout/layout'
import DefaultFooter from '../components/layout/footer/DefaultFooter'

const FormItem = Form.Item

class PasswordRecovery extends React.Component {
  componentDidMount() {
    this.props.initSendPasswordRequestEmail()
  }

  componentDidUpdate(prevProps) {
    const { error, t } = this.props
    if (error && error !== prevProps.error) {
      message.error(t(error))
      this.props.clearError()
    }
  }

  render() {
    const { t, sendPasswordRequestEmail, emailSent } = this.props

    return (
      <>
        <Head title={`${t('Iturria SA')} - ${t('password-recovery')}`} />

        <div className='login-layout'>
          <div className='login-container'>
            <div className='centered-form-and-image'>
              <div className='form-and-image-container'>
                <div className='computer-image-container'>
                  <img src='/static/laptop_login.png' className='computer-image' />
                </div>
                <div className='login-form'>
                  <div className='form-header'>
                    <div className='login-logo-container'>
                      <img src='/static/logo-login.png' />
                    </div>
                    <div>
                      <div className='login-title'>{t('password-recovery')}</div>
                    </div>
                  </div>
                  <div className='login-form-content password-recovery'>
                    {emailSent && <Alert message={t('password_recovery_sent')} type='success' />}
                    {!emailSent && (
                      <Formik
                        initialValues={{ email: '' }}
                        onSubmit={(values, actions) => {
                          this.props.clearError()
                          sendPasswordRequestEmail(values.email)
                          actions.setSubmitting(false)
                        }}
                        validationSchema={Yup.object().shape({
                          email: Yup.string()
                            .email(t('validation-email'))
                            .required(t('validation-required', { field: t('email') })),
                        })}
                      >
                        {({
                          values,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                          errors,
                          touched,
                          isValid,
                        }) => (
                          <Form onFinish={handleSubmit}>
                            <FormItem className={errors.email && touched.email ? 'has-error' : ''}>
                              <label className='login-input-label'>
                                <span>{t('insertYour')}</span>
                                <span className='input-label-bold'>{t('email')}:</span>
                              </label>
                              <Input
                                id='email'
                                type='email'
                                name='email'
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              {errors.email && touched.email && (
                                <div className='ant-form-explain has-error'>{errors.email}</div>
                              )}
                            </FormItem>

                            <Button
                              type='primary'
                              htmlType='submit'
                              disabled={!isValid || isSubmitting}
                              className='login-form-button recovery'
                            >
                              {t('Confirm')}
                            </Button>
                            <div className='form-login-footer pt-5'>
                              <a className='login-form-action recovery-note'>
                                <span style={{ fontWeight: 'bold' }}>{t('Remember')}</span> |{' '}
                                {t('password-recovery-note')}
                              </a>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          <Footer>
            <DefaultFooter />
          </Footer>
      </>
    )
  }
}

const mapStateToProps = ({ common, auth, users }) => {
  const { error, emailSent } = users.passwordRecovery
  return { error, emailSent }
}

const mapDispatchToProps = (dispatch) => ({
  initSendPasswordRequestEmail: () => {
    dispatch(initSendPasswordRequestEmail())
  },
  sendPasswordRequestEmail: (email) => {
    dispatch(sendPasswordRequestEmail({ email }))
  },
  clearError: () => {
    dispatch(clearError())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(withRouter(PasswordRecovery)))
